// Local translations
export const T = {
  en_GB: {
    noProductTypesConfigured: "No product types configured for this collection.",
  },
  nb_NO: {
    noProductTypesConfigured: "Ingen produkttyper konfigurert for denne samlingen.",
  },
} as const;
